module.exports = __webpack_public_path__ + "img/Dyeing_1200x800.9176f53b.png";